import MonitoraggioEcgEdit from "./components/MonitoraggioEcgEdit.vue";
import MonitoraggioEcgView from "./components/MonitoraggioEcgView.vue";
import MonitoraggioEcgList from "./components/MonitoraggioEcgList.vue";

export default {
    MonitoraggioEcgEdit,
    MonitoraggioEcgView,
    MonitoraggioEcgList,
};
